import { useEffect } from 'react'

/**
 * Injects a JSON-LD structured-data <script> into <head> for the current page
 * (e.g. SoftwareApplication, BlogPosting) and removes it on unmount.
 * Pass null to inject nothing.
 */
export function useJsonLd(data: object | null) {
  const json = data ? JSON.stringify(data) : null
  useEffect(() => {
    if (!json) return
    const el = document.createElement('script')
    el.type = 'application/ld+json'
    el.text = json
    document.head.appendChild(el)
    return () => el.remove()
  }, [json])
}
